import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, IconButton, Snackbar, SnackbarContent } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { textFieldStyles } from "../styles/textFieldStyles";
import CancelButton from "./CancelButton";
import SubmitButton from "./SubmitButton";
import { mediumTitle } from "../styles/typography";
import { useTranslation } from 'react-i18next';
import { formatDate } from "../utils/dateUtils";
const NotesDialog = ({ selectedFile, file, notes, newNote, newNoteDate, showNewNoteField, snackbarOpen, snackbarMessage, handleCloseNotes, handleAddNote, handleSaveAllNotes, handleDeleteNote, setNewNote, setShowNewNoteField, setNotes, setSnackbarOpen }) => {
  const { t } = useTranslation(['common', 'buttons']);
  return (
    <>
      <Dialog open={!!selectedFile} onClose={handleCloseNotes} maxWidth="md" fullWidth sx={{
        '& .MuiPaper-root': {
          borderRadius: '0', // Custom border radius
        },
      }}>
        <DialogTitle
        sx={{ ...mediumTitle, backgroundColor: "#0b212f", color: "#fff" }}>
          {t('common:notesFor')} {file?.fileNo} - {file?.name}
        </DialogTitle>
        <DialogContent>
          <div style={{ paddingTop: "2em" }}>
            {notes.map((note) => (
              <div key={note._id} style={{ marginBottom: "1em" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5em" }}>
                  <div style={{ marginRight: "1em", color: "#888", fontSize: "0.9em" }}>
                    {formatDate(note.date)}
                  </div>
                  <div style={{ color: "#666", fontSize: "0.9em", fontWeight: "500" }}>
                    {note.author
                      ? `${note.author.firstName || ''} ${note.author.lastName || ''}`.trim() || note.author.businessName || t('common:fallbacks.notAvailable')
                      : t('common:fallbacks.notAvailable')
                    }
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    fullWidth
                    multiline
                    value={note.content}
                    sx={textFieldStyles()}
                    onChange={(e) => {
                      const updatedNotes = notes.map((n) => (n._id === note._id ? { ...n, content: e.target.value } : n));
                      setNotes(updatedNotes);
                    }}
                  />
                  <IconButton onClick={() => handleDeleteNote(note._id)} >
                    <DeleteIcon />
                  </IconButton>
                </div>
              </div>
            ))}
          </div>
          {showNewNoteField && (
            <div style={{ display: "flex", alignItems: "center", marginBottom: "1em", paddingBottom: "1em" }}>
              <div style={{ marginRight: "1em", color: "#888" }}>{newNoteDate}</div>
              <TextField
                fullWidth
                multiline
                rows={4}
                value={newNote}
                onChange={(e) => setNewNote(e.target.value)}
                sx={textFieldStyles()}
                // style={{ marginTop: "1em" }}
              />
              <IconButton onClick={() => { setNewNote(""); setShowNewNoteField(false); }} >
                <DeleteIcon />
              </IconButton>
            </div>
          )}
        </DialogContent>
        <DialogActions style={{ backgroundColor: "#f5f5f5", paddingRight: "3rem" }}>

          {/* <Button onClick={handleAddNote} sx={{ backgroundColor: "#4a76ff", textTransform: "capitalize", borderRadius: 50, padding: "2px 30px", fontSize: "0.75rem" }} variant="contained">
            Add Note
          </Button> */}
          <SubmitButton onClick={handleAddNote} size="small">
          {t('buttons:primary.addNote')}
            </SubmitButton>
          <SubmitButton onClick={handleSaveAllNotes} size="small">
          {t('common:save')}
            </SubmitButton>
          {/* <Button onClick={handleSaveAllNotes} sx={{ backgroundColor: "#4a76ff", textTransform: "capitalize", borderRadius: 50, padding: "2px 30px", fontSize: "0.75rem" }} variant="contained">
            Save
          </Button> */}
          <CancelButton
              variant="outlined"
              onClick={handleCloseNotes}
              size="small"
            >
              {t('common:close')}
            </CancelButton>
          {/* <Button onClick={handleCloseNotes} sx={{ backgroundColor: "#4a76ff", textTransform: "capitalize", borderRadius: 50, padding: "2px 30px", fontSize: "0.75rem" }} variant="contained">
            Close
          </Button> */}
        </DialogActions>
      </Dialog>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
        <SnackbarContent
          message={
            <span style={{ display: "flex", alignItems: "center" }}>
              <CheckCircleIcon style={{ marginRight: "8px" }} />
              {snackbarMessage}
            </span>
          }
          style={{ backgroundColor: "#d4edda", color: "#155724" }}
        />
      </Snackbar>
    </>
  );
};

export default NotesDialog;